<template>
  <div class="panel-inner" v-show="showData">
    <p
      :style="getStandardPos(n)"
      v-for="(t, n) in standardList"
      v-bind:key="'standard-' + n"
    >
      {{ t }}
    </p>
    <div class="panel-handler"></div>
    <div class="panel-number">{{ circleData ? circleData["value"] : "" }}</div>
    <div class="panel-tag">{{ status }}</div>
    <div class="panel-bg"></div>
    <canvas ref="canvas" class="panel-content" width="100" height="100" />
    <div class="panel-title">
      {{ circleData ? circleData["device_name"] : "" }}
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { CircleProgress } from "../js/CircleProgress.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["circleData"],
  data() {
    //这里存放数据
    return {
      standardList: [0, 5, 10, 15, 20, 25, 30],
      showData: true
    };
  },
  //计算属性 类似于data概念
  computed: {
    getStandardPos() {
      return function (item) {
        if (item === 0) {
          return {
            position: "absolute",
            top: "70px",
            left: "20px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 1) {
          return {
            position: "absolute",
            top: "40px",
            left: "10px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 2) {
          return {
            position: "absolute",
            top: "15px",
            left: "20px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 3) {
          return {
            position: "absolute",
            top: "5px",
            left: "50px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 4) {
          return {
            position: "absolute",
            top: "15px",
            left: "75px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 5) {
          return {
            position: "absolute",
            top: "40px",
            left: "89px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 6) {
          return {
            position: "absolute",
            top: "70px",
            left: "83px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        }
      };
    },
    // circleShow() {
    //   if (this.circleData) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    status() {
      if (
        this.circleData &&
        +this.circleData.value <= +this.circleData.standard_data
      ) {
        return "正常";
      } else {
        return "异常";
      }
    },
  },
  //监控data中的数据变化
  watch: {
    circleData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.showData = true
          this.changeRotate(newVal["value"], "canvas-" + newVal["deviceNo"]);
        } else {
          this.showData = false
        }
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      if (this.circleData) {
        this.changeRotate(
          this.circleData["value"],
          "canvas-" + this.circleData["deviceNo"]
        );
      } else {
        this.showData = false
      }
    });
  },
  //方法集合
  methods: {
    changeRotate(num, nodeId) {
      let that = this;
      let deltaR = num / 30 > 1 ? 360 : (num / 30) * 360;

      $(this.$refs["canvas"])
        .parent()
        .find(".panel-handler")
        .css("transform", "rotateZ(" + 180 + "deg)");
      //$(node).parent().find(".panel-handler").css("transform", "rotateZ(180deg)");
      new CircleProgress({
          //canvasId: nodeId,
          node: $(this.$refs["canvas"]).get(0),
          r: 190, //默认100，半径
          w: 500, //画布宽，默认500
          h: 500, //画布高，默认500
          startAngle: 90 + 25, //起始角度，默认180
          endAngle: 90 + deltaR + 25, //终止角度，必须传
          interval: 200, //帧间隔时间，默认5ms
          duration: 1000, //动画时间，默认2000
          lineWidth: 90, //描边线宽度，默认15
          bgColor: "#ffffff00", //背景色，默认#cccc
          colors: {
            0: "#3B89F900",
            1: "#3B89F944",
          },
          type: "half", //画半圆或者圆，full｜half。默认full[半圆指从起始角度向终止角度过渡的半个圆]
          precision: 4,
        });
      this.$forceUpdate();
      setTimeout(function () {
        $(that.$refs["canvas"])
          .parent()
          .find(".panel-handler")
          .css("transform", "rotateZ(" + (180 + deltaR + 25) + "deg)");
      }, 50);
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.panel-inner {
  position: relative;
  width: 110px;
  height: 118px;
  background-size: 100% 100%;
  margin: 5px auto;
}
.panel-bg {
  background: url(../img/pan.png);
  position: absolute;
  width: 110px;
  height: 118px;
  background-size: 100% 100%;
  z-index: 99;
}

.panel-handler {
  background: url(../img/hand.png);
  position: absolute;
  width: 56px;
  height: 56px;
  background-size: 100% 100%;
  left: 27px;
  top: 27px;
  -webkit-transition: all 2s ease-out;
  -moz-transition: all 2s ease-out;
  transition: all 2s ease-out;
  transform: rotateZ(180deg);
}

.panel-number {
  width: 80px;
  height: 15px;
  font-size: 23px;
  font-family: "number";
  font-weight: 400;
  color: #47ffdd;
  line-height: 14px;
  position: absolute;
  top: 78px;
  left: 15px;
  text-align: center;
}

.panel-tag {
  width: 100px;
  height: 20px;
  font-size: 12px;
  font-family: "normalFont";
  font-weight: 400;
  color: #47ffdd;
  line-height: 20px;
  position: absolute;
  text-align: center;
  left: 5px;
  top: 102px;
  z-index: 100;
}

.panel-title {
  width: 150px;
  height: 14px;
  font-size: 12px;
  font-family: "normalFont";
  font-weight: 400;
  color: #c0d5d9;
  line-height: 14px;
  text-align: center;
  position: absolute;
  top: 135px;
  left: -20px;
}

.panel-content {
  position: absolute;
  top: 0px;
  left: 0px;
  transform-origin: top left;
}
</style>
